export default __webpack_public_path__ + "static/media/icthyology-new.af0a1949.jpg";